/* eslint-disable camelcase */
import {
  ADD_TO_CART,
  ADD_TO_CART_SUCCESS,
  ADD_VARIANT_IDS_OF_PRODUCTS_TO_HIDE,
  BALANCE_PRODUCT_ADDTIONS,
  COMMON,
  HIDE_EMBEDDED_MESSAGE,
  REMOVE_FROM_CART,
  REMOVE_FROM_STATE,
  SHOW_EMBEDDED_MESSAGE,
  SUBMIT_EVENT,
} from './constants';

export function commonFunction(datapack) {
  return {
    type: COMMON,
    datapack,
  };
}

export function sendEvent(datapack) {
  const {
    name,
    action,
    primary,
    offered,
    variables,
    added,
    isEmbedded,
    isProductPage,
  } = datapack;

  return {
    type: SUBMIT_EVENT,
    name,
    action,
    primary,
    offered,
    variables,
    added,
    isEmbedded,
    isProductPage,
  };
}

export function addToCart(datapack) {
  const {
    mrOfferID,
    variant,
    properties,
    isEmbedded,
    isProductPage,
    primary,
    variantsWithQuantity,
    isBottomBarButtonActionGoToCart,
    discountCode,
    theme,
    offerType,
    productId,
    variantId,
    productTitle,
    variantTitle,
    widgetID,
  } = datapack;
  return {
    type: ADD_TO_CART,
    mrOfferID,
    variant,
    properties,
    isEmbedded,
    isProductPage,
    primary,
    variantsWithQuantity,
    isBottomBarButtonActionGoToCart,
    discountCode,
    theme,
    offerType,
    productId,
    variantId,
    productTitle,
    variantTitle,
    widgetID,
  };
}

export function balanceProductAddtions(data) {
  return {
    type: BALANCE_PRODUCT_ADDTIONS,
    addtions: data.balance,
    widgetID: data.widgetID,
  };
}

export function removeFromCart(datapack) {
  return {
    type: REMOVE_FROM_CART,
    mrOfferID: datapack.mrOfferID,
    variant: datapack.variant,
    quantity: datapack.current_quantity,
    product_id: datapack.product_id,
    product_title: datapack.product_title,
    isEmbedded: datapack.isEmbedded,
    triggerType: datapack.triggerType,
    offerType: datapack.offerType,
    theme: datapack.theme,
  };
}

export function removeFromState(datapack) {
  return {
    type: REMOVE_FROM_STATE,
    variant_id: datapack.variant_id,
    old_quantity: datapack.old_quantity,
    product_id: datapack.product_id,
    variant_title: datapack.variant_title,
    product_title: datapack.product_title,
  };
}

export function addToCartSuccess(datapack) {
  const {
    mrOfferID,
    product_id,
    variant_id,
    isEmbedded,
    isProductPage,
    theme,
    offerType,
    widgetID,
  } = datapack;
  return {
    type: ADD_TO_CART_SUCCESS,
    datapack: {
      mrOfferID,
      product_id,
      variant_id,
      isEmbedded,
      isProductPage,
      theme,
      offerType,
      widgetID,
    },
  };
}

export function addVariantIdsOfProductsToHide(datapack) {
  const { ids } = datapack;
  return { type: ADD_VARIANT_IDS_OF_PRODUCTS_TO_HIDE, ids };
}
